import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { OrderGroupService } from '../../../_services/order-group.service';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-single-order-group-slots',
    templateUrl: './single-order-group-slots.component.html',
    styleUrls: ['./single-order-group-slots.component.css']
})
export class SingleOrderGroupSlotsComponent implements OnInit {

    tabitems: any = [];

    orderGroupId: any;
    selectedOrderGroup: any;
    orderGroupSlots: any[] = [];

    role: any;
    routeRole: any;
    cookieStore: any;
    storeId: any;

    createOrderGroupSlotForm: FormGroup;
    createOrderGroupSlotModal = false;

    selectedOrderGroupSlot = null;
    editOrderGroupSlotForm: FormGroup;

    constructor(
        fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public _orderGroupService: OrderGroupService,
        public cookieService: CookieService,
        public router: Router,
        public confirmationService: ConfirmationService
    ) {
        // Get Patient id from params
        this.activatedRoute.params.subscribe((params: Params) => {
            this.orderGroupId = params.id;
        });

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        // Handle Store Cookies
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.routeRole + '/select-store']);
        }

        this.tabitems = [
            { path: '/' + this.routeRole + '/order-groups/', title: 'All Workplace Groups', class: 'back-link' },
            { path: '/' + this.routeRole + '/order-groups/' + this.orderGroupId + '/details', title: 'Details' },
            { path: '/' + this.routeRole + '/order-groups/' + this.orderGroupId + '/slots', title: 'Slots' },
        ];

        this.createOrderGroupSlotForm = fb.group({
            cutOffTime: new FormControl(),
            fulfillmentTime: new FormControl(),
            name: new FormControl(),
            monday: new FormControl(false),
            tuesday: new FormControl(false),
            wednesday: new FormControl(false),
            thursday: new FormControl(false),
            friday: new FormControl(false),
            saturday: new FormControl(false),
            sunday: new FormControl(false)
        });

        this.editOrderGroupSlotForm = fb.group({
            cutOffTime: new FormControl(),
            fulfillmentTime: new FormControl(),
            name: new FormControl(),
            monday: new FormControl(),
            tuesday: new FormControl(),
            wednesday: new FormControl(),
            thursday: new FormControl(),
            friday: new FormControl(),
            saturday: new FormControl(),
            sunday: new FormControl()
        });

    }

    ngOnInit() {
        this.getOrderGroup(this.orderGroupId);
        this.getAllOrderGroupSlots(this.orderGroupId);
    }

    // Get Order Group by id
    public getOrderGroup(id) {
        this._orderGroupService.getOrderGroupById(id)
            .subscribe((data: any) => {
                // console.log(data);
                this.selectedOrderGroup = data;
            });
    }

    // Get all order group slots
    public getAllOrderGroupSlots(id) {
        this._orderGroupService.getAllWorkplaceSlotsByWorkplace(id)
            .subscribe((data: any) => {
                // console.log(data);
                this.orderGroupSlots = data;
            });
    }

    // Toggle create step modal
    public toggleCreateOrderGroupSlotModal() {
        this.createOrderGroupSlotModal = !this.createOrderGroupSlotModal;
    }

    public onCreateOrderGroupSlotFormSubmit() {
        const values = this.createOrderGroupSlotForm.value;
        const body = {
            cutOffTime: values.cutOffTime,
            fulfillmentTime: values.fulfillmentTime,
            name: values.name,
            monday: values.monday,
            tuesday: values.tuesday,
            wednesday: values.wednesday,
            thursday: values.thursday,
            friday: values.friday,
            saturday: values.saturday,
            sunday: values.sunday
        };
        this._orderGroupService.createWorkplaceSlot(this.orderGroupId, body)
            .subscribe((data: any) => {
                // console.log(data);
                this.getAllOrderGroupSlots(this.orderGroupId);
                this.toggleCreateOrderGroupSlotModal();
                this.notificationService.notify(
                    'success',
                    'Order Group Slot Created',
                    'Order Group Slot has successfully been created',
                    'top',
                    'right');
            })
    }

    // Select Slot
    public onRowSelect(event) {
        // console.log(event);
        this.selectedOrderGroupSlot = event.data;
        this.assignOrderGroupSlotFormValues();
    }

    public assignOrderGroupSlotFormValues() {
        this.editOrderGroupSlotForm.patchValue({
            cutOffTime: this.selectedOrderGroupSlot.cutoffTime,
            fulfillmentTime: this.selectedOrderGroupSlot.fulfillmentTime,
            name: this.selectedOrderGroupSlot.name,
            monday: this.selectedOrderGroupSlot.monday,
            tuesday: this.selectedOrderGroupSlot.tuesday,
            wednesday: this.selectedOrderGroupSlot.wednesday,
            thursday: this.selectedOrderGroupSlot.thursday,
            friday: this.selectedOrderGroupSlot.friday,
            saturday: this.selectedOrderGroupSlot.saturday,
            sunday: this.selectedOrderGroupSlot.sunday
        })
    }

    public onEditOrderGroupSlotFormSubmit() {
        const values = this.editOrderGroupSlotForm.value;

        const body = {
            cutOffTime: values.cutOffTime,
            fulfillmentTime: values.fulfillmentTime,
            name: values.name,
            monday: values.monday,
            tuesday: values.tuesday,
            wednesday: values.wednesday,
            thursday: values.thursday,
            friday: values.friday,
            saturday: values.saturday,
            sunday: values.sunday
        }

        this._orderGroupService.editWorkplaceSlot(this.selectedOrderGroupSlot.id, body)
            .subscribe((data: any) => {
                this.selectedOrderGroupSlot = null;
                this.getAllOrderGroupSlots(this.orderGroupId);
                this.notificationService.notify(
                    'success',
                    'Order Group Slot Updated',
                    'Order Group Slot has successfully been updated',
                    'top',
                    'right');
            })
    }

    public deleteSlot(slot) {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to delete this slot?',
            accept: () => {
                this._orderGroupService.deleteWorkplaceSlot(slot.id)
                    .subscribe((data: any) => {
                        // console.log(data);
                        this.selectedOrderGroupSlot = null;
                        this.getAllOrderGroupSlots(this.orderGroupId);
                        this.notificationService.notify(
                            'success',
                            'Order Group Slot Deleted',
                            'Order Group Slot has successfully been removed',
                            'top',
                            'right');
                    })
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/order-groups/single-order-group/single-order-group-slots/single-order-group-slots.component.ts